import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';
import { achievementsDPRoot } from '../achievements-meta';

const dpRoot = `${achievementsDPRoot}|Logos`;

const sharedProps: Pick<LocDef, 'feature' | 'portal'> = {
	feature: HubFeature.CredentialAchievementsLogoDownload,
	portal: 'CP',
};

export type AchievementLogosLoc =
	| 'CPAchievementLogosName'
	| 'CPAchievementLogosGroup'
	| 'CPAchievementLogosStatus'
	| 'CPAchievementLogosExpired'
	| 'CPAchievementLogosActive'
	| 'CPAchievementLogosDownloadButton'
	| 'CPAchievementLogosPageTitle'
	| 'CPAchievementLogosPageDescription'
	| 'CPAchievementLogosActions';

export const achievementLogosLocs: LocDefs<AchievementLogosLoc> = {
	CPAchievementLogosName: {
		defaultValue: 'Name',
		description: 'Field Label for name.',
		displayPath: `${dpRoot}|Name`,
		displayType: 'Label',
		legacyName: 'Credential.Achievements.LogoDownload/Achievements.Logos.FieldLabel.Name',
		htmlAllowed: false,
		...sharedProps,
	},
	CPAchievementLogosGroup: {
		defaultValue: 'Group',
		description: 'Field Label for group.',
		displayPath: `${dpRoot}|Group`,
		displayType: 'Label',
		legacyName: 'Credential.Achievements.LogoDownload/Achievements.Logos.FieldLabel.Group',
		htmlAllowed: false,
		...sharedProps,
	},
	CPAchievementLogosStatus: {
		defaultValue: 'Status',
		description: 'Field Label for status.',
		displayPath: `${dpRoot}|Status`,
		displayType: 'Label',
		htmlAllowed: false,
		...sharedProps,
	},
	CPAchievementLogosExpired: {
		defaultValue: 'Expired',
		description:
			'Content shown for the status of an achievement logo when it is already expired',
		displayPath: `${dpRoot}|Status|Expired`,
		displayType: 'Content',
		htmlAllowed: false,
		...sharedProps,
	},
	CPAchievementLogosActive: {
		defaultValue: 'Active',
		description: 'Content shown for the status of an achievement logo when it is active',
		displayPath: `${dpRoot}|Status|Active`,
		displayType: 'Content',
		htmlAllowed: false,
		...sharedProps,
	},
	CPAchievementLogosDownloadButton: {
		defaultValue: 'Download',
		description: 'Text for the button to download achievement logo.',
		displayPath: `${dpRoot}|Download Button`,
		displayType: 'Button',
		legacyName:
			'Credential.Achievements.LogoDownload/Credentials.Achievements.Logos.Button.Download',
		htmlAllowed: false,
		...sharedProps,
	},
	CPAchievementLogosPageTitle: {
		defaultValue: 'Download Logos',
		description: 'Text for the page title of the achievements logo download page.',
		displayPath: `${dpRoot}|Page Title`,
		displayType: 'Title',
		legacyName:
			'Credential.Achievements.LogoDownload/Credentials.Achievements.Logos.Title.Pagetitle',
		htmlAllowed: false,
		...sharedProps,
	},
	CPAchievementLogosPageDescription: {
		defaultValue: '',
		description: 'Description for the download achievements logo page for candidates',
		displayPath: `${dpRoot}|Page Description`,
		displayType: 'Content',
		legacyName:
			'Credential.Achievements.LogoDownload/Credentials.Achievements.Logos.Content.PageDescription',
		htmlAllowed: true,
		...sharedProps,
	},
	CPAchievementLogosActions: {
		defaultValue: '',
		description: 'Field label for actions',
		displayPath: `${dpRoot}|Actions`,
		displayType: 'Label',
		htmlAllowed: false,
		...sharedProps,
	},
};
export const LOC_KEYS = MapLocKeys<AchievementLogosLoc>(achievementLogosLocs);
export type CpAchievementLogosLocType = LocMap<AchievementLogosLoc>;
